<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcJobInfoFrom',

    props: {
        initialData: null,
        jobTypes: {
            type: Array,
            default: () => [],
        },
        agricultureIds: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            loading: false,
            model: null,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    computed: {
        isAgriculture() {
            return Boolean(this.model.$.individual_activities.find(id => this.agricultureIds.includes(id)));
        },

        jobTypesList() {
            return this.model.$.job_types.map(jobTypeId => this.jobTypes.find(jobType => jobType.id === jobTypeId).type);
        },
    },

    methods: {
        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('/registracija/informacija-apie-veikla', this.model.$);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },

        addHiredWorkplace() {
            this.model.$.hired_workplaces.push({ workplace: '', job_title: '' });
        },

        removeHiredWorkplace(relation) {
            const index = this.model.$.hired_workplaces.indexOf(relation);

            if (index > 0) {
                this.model.$.hired_workplaces = this.model.$.hired_workplaces.filter(item => item !== relation);
            }
        },
    },
};
</script>
